import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconSentimentSvg } from "./IconSentimentSvg.mjs";
import { IconSentimentNegativeSvg } from "./IconSentimentNegativeSvg.mjs";
import { IconSentimentPositiveSvg } from "./IconSentimentPositiveSvg.mjs";
const feelingToIcon = {
  positive: IconSentimentPositiveSvg,
  negative: IconSentimentNegativeSvg,
  neutral: IconSentimentSvg
};
const IconSentiment = ({
  feeling = "neutral",
  ...props
}) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: feelingToIcon[feeling] || feelingToIcon.neutral,
      ...iconProps
    }
  );
};
export {
  IconSentiment
};
